import { useAuth } from "@/shared/hooks/useAuth";
import { IApp } from "@/shared/types/apps";
import { FunctionComponent } from "react";
import styles from "./GameDetails.module.css";

interface Props {
  game: IApp;
  onPlayGame: () => void;
}

export const GameDetails: FunctionComponent<Props> = ({ game, onPlayGame }) => {
  const { isAuthenticated } = useAuth();

  const getGameImage = () => {
    if (game.url && game.url.startsWith("http")) {
      return game.url;
    }
    return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0yMDAgMTUwQzIyNS40NjMgMTUwIDI0NiAxNzAuNTM3IDI0NiAxOTZDMjQ2IDIyMS40NjMgMjI1LjQ2MyAyNDIgMjAwIDI0MkMxNzQuNTM3IDI0MiAxNTQgMjIxLjQ2MyAxNTQgMTk2QzE1NCAxNzAuNTM3IDE3NC41MzcgMTUwIDIwMCAxNTBaIiBmaWxsPSIjOUI5QkEwIi8+CjxwYXRoIGQ9Ik0yMDAgMjUwQzE3NC41MzcgMjUwIDE1NCAyNzAuNTM3IDE1NCAyOTZDMjU0IDI5NiAyNTQgMjcwLjUzNyAyNTQgMjk2QzI1NCAyNzAuNTM3IDIyNS40NjMgMjUwIDIwMCAyNTBaIiBmaWxsPSIjOUI5QkEwIi8+Cjwvc3ZnPgo=";
  };

  const screenshots = [
    // { id: 1, url: getGameImage(), alt: `${game.title} - скриншот 1` },
    // { id: 2, url: getGameImage(), alt: `${game.title} - скриншот 2` },
    // { id: 3, url: getGameImage(), alt: `${game.title} - скриншот 3` },
    // { id: 4, url: getGameImage(), alt: `${game.title} - скриншот 4` },
  ] as { id: number; url: string; alt: string }[];

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.imageContainer}>
            <img
              src={getGameImage()}
              alt={game.title}
              className={styles.image}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = "none";
              }}
            />
          </div>

          <div className={styles.info}>
            <div>
              <h1 className={styles.title}>{game.title}</h1>
              <p className={styles.shortDescription}>
                {game.short_description}
              </p>
            </div>

            <div className={styles.actions}>
              <button onClick={onPlayGame} className={styles.playButton}>
                {isAuthenticated ? "Начать играть" : "Войти и играть"}
              </button>

              {!isAuthenticated && (
                <p className={styles.authHint}>
                  Требуется авторизация для доступа к игре
                </p>
              )}
            </div>

            <div className={styles.meta}>
              <div>
                <p className={styles.metaLabel}>Дата добавления</p>
                <p className={styles.metaValue}>
                  {new Date(game.created).toLocaleDateString("ru-RU")}
                </p>
              </div>
              <div>
                <p className={styles.metaLabel}>Обновлено</p>
                <p className={styles.metaValue}>
                  {new Date(game.last_updated).toLocaleDateString("ru-RU")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

          {screenshots.length > 0 && (
      <div className={styles.card}>
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Скриншоты</h2>
          <div className={styles.screenshotsGrid}>
            <div className={styles.screenshots}>
              {screenshots.map((screenshot) => (
                <div key={screenshot.id} className={styles.screenshot}>
                  <img
                    src={screenshot.url}
                    alt={screenshot.alt}
                    className={styles.screenshotImage}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = "none";
                    }}
                  />
                </div>
              ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <div className={styles.card}>
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Об игре</h2>

          <div className={styles.description}>
            <p className={styles.descriptionText}>
              {game.long_description || game.short_description}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Информация</h2>

          <div className={styles.infoGrid}>
            <div className={styles.infoItem}>
              <p className={styles.infoLabel}>Название</p>
              <p className={styles.infoValue}>{game.title}</p>
            </div>

            <div className={styles.infoItem}>
              <p className={styles.infoLabel}>Дата добавления</p>
              <p className={styles.infoValue}>
                {new Date(game.created_at).toLocaleDateString("ru-RU")}
              </p>
            </div>

            <div className={styles.infoItem}>
              <p className={styles.infoLabel}>Последнее обновление</p>
              <p className={styles.infoValue}>
                {new Date(game.updated_at).toLocaleDateString("ru-RU")}
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
